import "./index.css";
import "./App.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import {
  Configuration as PublicClientApplicationConfiguration,
  PublicClientApplication,
} from "@azure/msal-browser";
import { apiBaseUrl, authority, clientId } from "./config";
import { ChakraProvider, Container, Flex } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import Fonts from "./theme/fonts";
import { theme } from "./theme/theme";
import { AppHeader } from "./compositions/AppHeader";
import { AppFooter } from "./compositions/AppFooter";
import { client } from "./clients/KompasApi/client.gen";

const root = ReactDOM.createRoot(document.getElementById("root")!);

client.setConfig({
  baseUrl: apiBaseUrl,
});

const configuration: PublicClientApplicationConfiguration = {
  auth: {
    authority,
    clientId,
    redirectUri: window.location.origin,
  },
};

const pca = new PublicClientApplication(configuration);

root.render(
  <React.StrictMode>
    <MsalProvider instance={pca}>
      <BrowserRouter>
        <ChakraProvider resetCSS theme={theme}>
          <Fonts />
          <Container
            as={Flex}
            direction="column"
            h="100dvh"
            m={0}
            maxH="100vh"
            maxW="100vw"
            overflow="hidden"
            p={0}
            w="full"
          >
            <AppHeader />
            <App />
            <AppFooter />
          </Container>
        </ChakraProvider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
